<template>
    <div class="flexwrap centercenter" style="flex-direction: column" id="landingPageHowBody">
      <h1 style="margin-top: -2vw; margin-bottom: 1vw; font-size: 2.5em">
        La méthode</h1>
      <component id="landingPageHowGroup"  :is="isMobile?'carousel':'div'"
                 :perPage="1" :minSwipeDistance="50" :paginationEnabled="true" :touchDrag="true" :autoplay="false" :loop="true"
                 :autoplayTimeout="3500" paginationActiveColor="var(--goalColor)" paginationColor="#ffffff88" :paginationPadding="5" >

        <component class="landingPageHowItem" style="grid-column: 1/3" :is="isMobile?'slide':'div'">
          <landing-page-bloc
                             title="Trouve une série adaptée à tes besoins" :image="Find_Show"
                             :icon="'fa-magnifying-glass'"
                             :color1="'white'" :color2="'var(--navBackgroundColor)'">
            <span><i class="fa-solid fa-arrow-right"></i> Regroupement des différentes séries par niveau de A2 à C1.</span>
            <span><i class="fa-solid fa-arrow-right"></i> Indicateurs de longueur, difficulté, fatigue pour chaque série.</span>
            <span><i class="fa-solid fa-arrow-right"></i> A venir : Accompagnement dans le choix d’une série adaptée à ton niveau, sur le thème de ton choix et qui fonctionne bien avec la méthode Learn and Watch.</span>
          </landing-page-bloc>
        </component>

        <component class="landingPageHowItem" :is="isMobile?'slide':'div'">
          <landing-page-bloc title="Learn" :image="Learn"
                             :icon="'fa-graduation-cap'" :color1="'var(--learnColor)'" :color2="'#007a9d'">
            <span><i class="fa-solid fa-arrow-right"></i> Apprends le vocabulaire utile de chaque épisode avec différents mécanismes de mémorisation (association sémantique, sonore et orthographique).</span>
            <span><i class="fa-solid fa-arrow-right"></i> Construit petit à petit un lexique au fil de la saison.</span>

          </landing-page-bloc>
        </component>

        <component class="landingPageHowItem" :is="isMobile?'slide':'div'">
          <landing-page-bloc title="Watch" :image="Watch"
                             :icon="'fa-tv-retro'"
                             :color1="'var(--watchColor)'"
                             :color2="'#b92945'" image-left="true">
            <span><i class="fa-solid fa-arrow-right"></i> Mets-toi dans de bonnes conditions pour être bien concentré.</span>
            <span><i class="fa-solid fa-arrow-right"></i> Lis le synopsis pour te (re)familiariser avec le contexte de l'épisode. </span>
            <span><i class="fa-solid fa-arrow-right"></i> Relis une dernière fois le vocabulaire que tu viens d'apprendre. </span>
            <span><i class="fa-solid fa-arrow-right"></i> Regarde l'épisode en VO sous-titré anglais sur Netflix. </span>
          </landing-page-bloc>
        </component>

        <component class="landingPageHowItem" :is="isMobile?'slide':'div'">
          <landing-page-bloc title="Check" :image="Check"
           :icon="'fa-tasks'"
                             :color1="'#ff8746'" :color2="'#c75e31'">
            <span><i class="fa-solid fa-arrow-right"></i> Vérifie ta compréhension de l'épisode avec un questionnaire. (Disponible en version bêta sur une selection de séries)</span>
            <span><i class="fa-solid fa-arrow-right"></i> A venir : Résumé de l'épisode en anglais et en français pour s'assurer d'avoir bien tout compris avant de passer à l'épisode suivant.</span>
          </landing-page-bloc>
        </component>

        <component class="landingPageHowItem" :is="isMobile?'slide':'div'">
          <landing-page-bloc title="Play" :image="Play"
          image-left="true"
                             :icon="'fa-dice'"
                             :color1="'#23c26e'" :color2="'#159a54'">
            <span><i class="fa-solid fa-arrow-right"></i> Valide tes acquis avec un jeu de pendu.</span>
            <span><i class="fa-solid fa-arrow-right"></i> A venir : deux nouveaux jeux pour avoir plus de diversité d'apprentissage et de révision du vocabulaire de l'épisode.</span>
          </landing-page-bloc>
        </component>




        <component class="landingPageHowItem" :is="isMobile?'slide':'div'" style="grid-column: 1/3">
          <landing-page-bloc
              title="Suis ta progression au fil du temps" :image="Stats"
              image-left="true"
              :icon="'fa-chart-line'"
              :color1="'white'" :color2="'var(--navBackgroundColor)'"
          >
            <span><i class="fa-solid fa-arrow-right"></i> Suis le nombre de mots que tu as appris.</span>
            <span><i class="fa-solid fa-arrow-right"></i> Fixe toi un objectif de nombre de sessions et essaie de le remplir chaque semaine.</span>
            <span><i class="fa-solid fa-arrow-right"></i> Gagne des badges au fil de tes accomplissements.</span>
            <span><i class="fa-solid fa-arrow-right"></i> Révise le vocabulaire de ta saison en cours.</span>
          </landing-page-bloc>
        </component>

    </component>

    </div>

</template>

<script>
import {Carousel, Slide} from "vue-carousel";
import {mapGetters} from "vuex";
import Find_Show from "@/assets/landing_page/Find_show.webp";
import Learn from "@/assets/landing_page/Learn.webp";
import Watch from "@/assets/landing_page/Watch.webp";
import Check from "@/assets/landing_page/Check.webp";
import Play from "@/assets/landing_page/Play.webp";
import Stats from "@/assets/landing_page/Stats.webp";
export default {
  name: "landingPageHow",
  components: {
    Carousel,
    Slide,
    LandingPageBloc: () => import(/* webpackPrefetch: true */ '@/components/landingPageBloc.vue')},

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
  data(){
    return{
      Find_Show,
      Learn,
      Watch,
      Check,
      Play,
      Stats,
    }
  }
}
</script>

<style scoped>
  #landingPageHowBody{
    justify-self: center;
    display: grid;
    justify-items: center;
    justify-content: center;
    width: 100%;
    transform: translateX(calc(23vw - 50%));
    grid-gap: 2vw;
  }
  #landingPageHowGroup{
    display:grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr;
    grid-gap: 2vw;
    align-items: center;
    justify-items: center;
  }

  @media screen and (max-device-width: 767px) {
    #landingPageHowBody{
      width: 100%;
      transform: translateX(0);
    }
    #landingPageHowGroup{
      height: fit-content;
      width: 100vw;
      display: block;
      justify-self: center;
    }
    .landingPageHowItem{
      width: 84vw;
      max-width: 84vw;
      margin: 0 8vw 0 8vw;
    }
  }
</style>